export async function installMadeForYou() {
  const { NWProjectDirectoryMadeForYouView, MadeForYouTile, MadeForYouStore } = await import(
    "@/wc/pages/project/features/directory/features/madeForYou/index.tsx"
  );

  MadeForYouStore.fetchMadeForYou();

  return { MadeForYou: NWProjectDirectoryMadeForYouView, MadeForYouTile };
}
